export default {
  computed: {
    jpModuleName() {
      return this.$store.state.global.currentModuleRouteParam
    }
  },
  methods: {
    onStartDraggable(evt) {
      this.jsonPatchDraftPath(evt.item._underlying_vm_)
    },

    onDraggableChanged(evt) {
      const operationType =  Object.keys(evt)[0]

      this.$store.dispatch('jsonPatches/createJsonPatchFromDraft', {
        selectedWidget: this.model,
        pathToTarget: `Modules.${this.jpModuleName}`,
        operationType,
        value: evt[operationType].element
      })
    },

    jsonPatchReplace(selectedWidget, propertyName, value, oldValue) {
      this.$store.dispatch('jsonPatches/createReplacePatch', {
        selectedWidget,
        pathToTarget: `Modules.${this.jpModuleName}`,
        propertyName,
        value,
        publish: true,
        oldValue
      })
    },
    
    jsonPatchRemove(selectedWidget) {
      this.$store.dispatch('jsonPatches/createRemovePatch', {
        pathToTarget: `Modules.${this.jpModuleName}`,
        selectedWidget,
        publish: true
      })
    },

    jsonPatchDraftPath(selectedWidget) {
      this.$store.dispatch('jsonPatches/createDraftWidgetPath', {
        pathToTarget: `Modules.${this.jpModuleName}`,
        selectedWidget
      })
    }
  }
}